import { render, staticRenderFns } from "./zone-v2.vue?vue&type=template&id=3b88487e&scoped=true&"
import script from "./zone-v2.component.ts?vue&type=script&lang=ts&"
export * from "./zone-v2.component.ts?vue&type=script&lang=ts&"
import style0 from "./zone-v2.scss?vue&type=style&index=0&id=3b88487e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88487e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b88487e')) {
      api.createRecord('3b88487e', component.options)
    } else {
      api.reload('3b88487e', component.options)
    }
    module.hot.accept("./zone-v2.vue?vue&type=template&id=3b88487e&scoped=true&", function () {
      api.rerender('3b88487e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zone-v2/zone-v2.vue"
export default component.exports